import { getUserName } from '../helpers/decode-username'
import { baseRequest } from './index'

import storage from 'local-storage-fallback'
import humps from 'humps'
import ErrorTracking from '../error-tracking'

import { ApiError } from 'redux-api-middleware'

export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILURE = 'AUTH_FAILURE'

export function authenticate (data) {
  const remember = data.remember
  return baseRequest({
    url: '/login',
    method: 'POST',
    body: { session: data },
    actions: [ AUTH_REQUEST, AUTH_SUCCESS, AUTH_FAILURE ],
    authenticated: false,
    errorInterceptor: (data, response) => {
      throw new ApiError(response.status, response.statusText, response)
    },
    responseInterceptor: (data, response) => {
      const token = response.headers.get('X-Auth-Token')
      const email = data.user.email
      const type = data.user.type
      const hasAcceptedTerms = data.user.tos_accepted
      const locationIds = data.user.location_ids
      const id = data.user.id

      if (remember === true) {
        storage.setItem('remember', true)
        storage.setItem('type', type)
        storage.setItem('token', token)
        storage.setItem('email', email)
        storage.setItem('userName', getUserName(token))
        storage.setItem('hasAcceptedTerms', hasAcceptedTerms)
        storage.setItem('locationIds', JSON.stringify(locationIds))
        storage.setItem('id', id)
      } else {
        storage.setItem('remember', false)
        window.sessionStorage.setItem('type', type)
        window.sessionStorage.setItem('token', token)
        window.sessionStorage.setItem('email', email)
        window.sessionStorage.setItem('hasAcceptedTerms', hasAcceptedTerms)
        window.sessionStorage.setItem('userName', getUserName(token))
        window.sessionStorage.setItem('locationIds', JSON.stringify(locationIds))
        window.sessionStorage.setItem('id', id)
      }

      ErrorTracking.setUser(data.user)

      return {
        body: response,
        hasAcceptedTerms,
        type,
        token,
        email,
        locationIds,
        id
      }
    }
  })
}

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE'

export function sendPasswordReset (data) {
  return baseRequest({
    url: '/reset_password',
    method: 'POST',
    body: { password_reset: data },
    actions: [ RESET_PASSWORD_REQUEST, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_FAILURE ],
    authenticated: false,
    responseInterceptor: (succ, response) => ({ email: data.email, ...succ }),
    errorInterceptor: (err, response) => ({ email: data.email, ...err})
  })
}

export const LOGOUT = 'LOGOUT'

export function logout () {
  storage.clear()
  window.sessionStorage.clear()

  return {
    type: LOGOUT
  }
}

export const UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN'

export function updateAuthToken () {
  return {
    type: UPDATE_AUTH_TOKEN
  }
}

export const ACCEPT_TERMS_REQUEST = 'ACCEPT_TERMS_REQUEST'
export const ACCEPT_TERMS_SUCCESS = 'ACCEPT_TERMS_SUCCESS'
export const ACCEPT_TERMS_FAILURE = 'ACCEPT_TERMS_FAILURE'

export function acceptTerms () {
  return baseRequest({
    url: '/users/approve_tos',
    method: 'POST',
    body: {},
    actions: [ ACCEPT_TERMS_REQUEST, ACCEPT_TERMS_SUCCESS, ACCEPT_TERMS_FAILURE ],
    responseInterceptor: (data, response) => {
      const status = data.user.tos_accepted

      if (storage.getItem('remember') == 'true') {
        storage.setItem('hasAcceptedTerms', status)
      } else {
        window.sessionStorage.setItem('hasAcceptedTerms', status)
      }

      return {
        hasAcceptedTerms: status
      }
    }
  })
}

export const UNREAD_NOTIFICATIONS_REQUEST = 'UNREAD_NOTIFICATIONS_REQUEST'
export const UNREAD_NOTIFICATIONS_SUCCESS = 'UNREAD_NOTIFICATIONS_SUCCESS'
export const UNREAD_NOTIFICATIONS_FAILURE = 'UNREAD_NOTIFICATIONS_FAILURE'

export function loadUnreadNotifications () {
  return baseRequest({
    url: '/users/unread_notifications',
    method: 'GET',
    actions: [ UNREAD_NOTIFICATIONS_REQUEST, UNREAD_NOTIFICATIONS_SUCCESS, UNREAD_NOTIFICATIONS_FAILURE ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const LOCATION_TOTAL_ISSUES_REQUEST = 'LOCATION_TOTAL_ISSUES_REQUEST'
export const LOCATION_TOTAL_ISSUES_SUCCESS = 'LOCATION_TOTAL_ISSUES_SUCCESS'
export const LOCATION_TOTAL_ISSUES_FAILURE = 'LOCATION_TOTAL_ISSUES_FAILURE'

export function loadLocationIssuesCount () {
  return baseRequest({
    url: '/locations/total_issues',
    method: 'GET',
    actions: [ LOCATION_TOTAL_ISSUES_REQUEST, LOCATION_TOTAL_ISSUES_SUCCESS, LOCATION_TOTAL_ISSUES_FAILURE ],
    responseInterceptor: (data, response) => {
      return { ...humps.camelizeKeys(data) }
    }
  })
}

export const READ_IN_PROGRESS_NOTIFICATIONS_REQUEST = 'READ_IN_PROGRESS_NOTIFICATIONS_REQUEST'
export const READ_IN_PROGRESS_NOTIFICATIONS_SUCCESS = 'READ_IN_PROGRESS_NOTIFICATIONS_SUCCESS'
export const READ_IN_PROGRESS_NOTIFICATIONS_FAILURE = 'READ_IN_PROGRESS_NOTIFICATIONS_FAILURE'

export function readInProgressNotifications () {
  return baseRequest({
    url: '/users/read_notifications/in_progress',
    method: 'POST',
    actions: [ READ_IN_PROGRESS_NOTIFICATIONS_REQUEST, READ_IN_PROGRESS_NOTIFICATIONS_SUCCESS, READ_IN_PROGRESS_NOTIFICATIONS_FAILURE ]
  })
}

export const READ_ISSUE_NOTIFICATIONS_REQUEST = 'READ_ISSUE_NOTIFICATIONS_REQUEST'
export const READ_ISSUE_NOTIFICATIONS_SUCCESS = 'READ_ISSUE_NOTIFICATIONS_SUCCESS'
export const READ_ISSUE_NOTIFICATIONS_FAILURE = 'READ_ISSUE_NOTIFICATIONS_FAILURE'

export function readIssueNotifications () {
  return baseRequest({
    url: '/users/read_notifications/issue',
    method: 'POST',
    actions: [ READ_ISSUE_NOTIFICATIONS_REQUEST, READ_ISSUE_NOTIFICATIONS_SUCCESS, READ_ISSUE_NOTIFICATIONS_FAILURE ]
  })
}

export const INCREMENT_IN_PROGRESS_UNREAD_NOTIFICATIONS = 'INCREMENT_IN_PROGRESS_UNREAD_NOTIFICATIONS'

export function incrementInProgressUnreadNotifications (incrementAmount = 1) {
  return {
    type: INCREMENT_IN_PROGRESS_UNREAD_NOTIFICATIONS,
    incrementAmount
  }
}

export const INCREMENT_ISSUE_UNREAD_NOTIFICATIONS = 'INCREMENT_ISSUE_UNREAD_NOTIFICATIONS'

export function incrementIssueUnreadNotifications (incrementAmount = 1) {
  return {
    type: INCREMENT_ISSUE_UNREAD_NOTIFICATIONS,
    incrementAmount
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.js